import { useState } from "react";
import { ImageUp, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { errMsg, uploadFile } from "@/lib/api";
import { resolveDocumentIdentity } from "@/lib/documentIdentity";

export default function DocumentIdentityFields({ value, onChange, settings, testIdPrefix = "document" }) {
  const [uploading, setUploading] = useState(false);
  const identity = resolveDocumentIdentity(value, settings);
  const inputCls = "w-full bg-white border border-slate-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A227]";
  const labelCls = "text-xs font-bold uppercase tracking-widest text-slate-500 block mb-1.5";

  const update = (patch) => onChange({ ...value, ...patch });
  const uploadLogo = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Logo harus berupa gambar");
    if (file.size > 5 * 1024 * 1024) return toast.error("Ukuran logo maksimal 5 MB");
    setUploading(true);
    try {
      const url = await uploadFile(file);
      update({ business_logo: url });
      toast.success("Logo dokumen berhasil diunggah");
    } catch (error) {
      toast.error(errMsg(error));
    } finally {
      setUploading(false);
    }
  };

  return (
    <section className="rounded-md border border-slate-200 bg-slate-50 p-4" data-testid={`${testIdPrefix}-identity-fields`}>
      <div className="mb-3">
        <p className="text-sm font-bold text-[#0B1F3A]">Identitas bisnis pada dokumen</p>
        <p className="text-xs text-slate-500">Nama, logo, dan WhatsApp ini hanya berlaku untuk dokumen ini.</p>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <label className={labelCls}>Nama Bisnis</label>
          <input value={value.business_name || ""} onChange={(event) => update({ business_name: event.target.value })} data-testid={`${testIdPrefix}-business-name`} className={inputCls} placeholder={identity.name} />
        </div>
        <div>
          <label className={labelCls}>Nomor WhatsApp Bisnis</label>
          <input value={value.business_whatsapp || ""} onChange={(event) => update({ business_whatsapp: event.target.value })} data-testid={`${testIdPrefix}-business-whatsapp`} className={inputCls} placeholder={identity.whatsapp} />
        </div>
        <div className="sm:col-span-2">
          <label className={labelCls}>Logo Bisnis</label>
          <div className="flex flex-wrap items-center gap-3">
            <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-md border border-slate-200 bg-white">
              <img src={identity.logo} alt={`Logo ${identity.name}`} className="h-full w-full object-contain p-1" />
            </div>
            <label className="inline-flex cursor-pointer items-center gap-2 rounded-md border border-slate-300 bg-white px-3 py-2 text-xs font-bold text-slate-700 hover:border-[#0B1F3A]">
              <ImageUp className="h-4 w-4" /> {uploading ? "Mengunggah..." : "Unggah / Ganti Logo"}
              <input type="file" accept="image/*" disabled={uploading} onChange={uploadLogo} data-testid={`${testIdPrefix}-business-logo`} className="sr-only" />
            </label>
            <button type="button" onClick={() => update({ business_logo: "" })} className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-500 hover:text-[#0B1F3A]">
              <RotateCcw className="h-3.5 w-3.5" /> Logo default
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
